import Hero from './components/Hero';
import Context from './components/Context';
import PainPoints from './components/PainPoints';
import Marketing360 from './components/Marketing360';
import Methodology from './components/Methodology';
import Leadership from './components/Leadership';
import Services from './components/Services';
import SocialProof from './components/SocialProof';
import CTAForm from './components/CTAForm';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Context />
      <PainPoints />
      <Marketing360 />
      <Methodology />
      <Leadership />
      <Services />
      <SocialProof />
      <CTAForm />
      <Footer />
    </div>
  );
}
